import {Injectable} from '@angular/core';

export interface BadgeItem {
    type: string;
    value: string;
}

export interface ChildrenItems {
    state: string;
    target?: boolean;
    name: string;
    type?: string;
    children?: ChildrenItems[];
}

export interface MainMenuItems {
    state: string;
    short_label?: string;
    main_state?: string;
    target?: boolean;
    name: string;
    type: string;
    icon: string;
    badge?: BadgeItem[];
    children?: ChildrenItems[];
}

export interface Menu {
    label: string;
    main: MainMenuItems[];
}

const MENUITEMS = { ROLE_ADMIN: [
    {
        label: 'TRANS_MAIN_MENU.TRANS_GENERAL',
        main: [
            {
                state: 'dashboard',
                short_label: 'D',
                name: 'TRANS_MAIN_MENU.TRANS_DASHBOARD',
                type: 'link',
                icon: 'ti-home',
            },
            {
                state: 'profile',
                short_label: 'S',
                name: 'TRANS_MAIN_MENU.TRANS_PROFILE',
                type: 'link',
                icon: 'ti-user'
            },
            {
                state: 'userpassword',
                short_label: 'P',
                name: 'TRANS_MAIN_MENU.TRANS_CHANGE_PASS',
                type: 'link',
                icon: 'ti-lock'
            }
        ]
    },
    {
        label: 'TRANS_MAIN_MENU.TRANS_APP_CULTURE_APP',
        main: [
            {
                state: 'screens',
                short_label: 'S',
                name: 'TRANS_MAIN_MENU.TRANS_SCREEN',
                type: 'sub',
                icon: 'ti-ink-pen',
                children: [
                    {
                        state: 'first',
                        name: 'TRANS_MAIN_MENU.TRANS_SCREEN_1',
                    },
                    {
                        state: 'second',
                        name: 'TRANS_MAIN_MENU.TRANS_SCREEN_2',
                    },
                    {
                        state: 'screens',
                        name: 'TRANS_MAIN_MENU.TRANS_SCREEN_3',
                    }
                ]
            },
            {
                state: 'sites',
                short_label: 'Α',
                name: 'TRANS_MAIN_MENU.TRANS_ARCHEOLOGICAL_SITES',
                type: 'sub',
                icon: 'ti-ink-pen',
                children: [
                    {
                        state: 'list',
                        name: 'TRANS_MAIN_MENU.TRANS_VIEW_ALL'
                    },
                    {
                        state: 'create',
                        name: 'TRANS_MAIN_MENU.TRANS_CREATE'
                    },
                ]
            },
            {
                state: 'monuments',
                short_label: 'M',
                name: 'TRANS_MAIN_MENU.TRANS_MONUMENTS',
                type: 'sub',
                icon: 'ti-crown',
                children: [
                    {
                        state: 'monuments-view-all',
                        name: 'TRANS_MAIN_MENU.TRANS_VIEW_ALL'
                    },
                    {
                        state: 'monuments-view-create',
                        name: 'TRANS_MAIN_MENU.TRANS_CREATE'
                    }
                ]
            },
            {
                state: 'updates',
                short_label: 'U',
                name: 'TRANS_MAIN_MENU.TRANS_UPDATES',
                type: 'link',
                icon: 'ti-reload rotate-refresh',
                badge: [
                    {
                        type: 'warning',
                        value: '2'
                    }
                ]
            },
            {
                state: 'push-notifications',
                short_label: 'U',
                name: 'TRANS_MAIN_MENU.TRANS_PUSH_NOTIFICATIONS',
                type: 'link',
                icon: 'ti-upload'
            },
            {
                state: 'ratings',
                short_label: 'R',
                name: 'TRANS_MAIN_MENU.TRANS_RATINGS',
                type: 'link',
                icon: 'ti-star'
            }
        ]
    },
    {
        label: 'TRANS_MAIN_MENU.TRANS_B2B',
        main: [
            {
                main_state: 'partners',
                state: 'list',
                short_label: 'C',
                name: 'TRANS_MAIN_MENU.TRANS_PARTNERS',
                type: 'link',
                icon: 'ti-agenda'
            },
            {
                state: 'groups',
                short_label: 'G',
                name: 'TRANS_MAIN_MENU.TRANS_GROUPS',
                type: 'link',
                icon: 'ti-signal',
            },
            {
                state: 'guides',
                short_label: 'H',
                name: 'TRANS_MAIN_MENU.TRANS_GUIDES',
                type: 'link',
                icon: 'ti-direction-alt'
            },
            {
                state: 'coupons',
                short_label: 'Ι',
                name: 'TRANS_MAIN_MENU.TRANS_COUPONS',
                type: 'link',
                icon: 'ti-medall-alt'
            },
            {
                state: 'notifications',
                short_label: 'j',
                name: 'TRANS_MAIN_MENU.TRANS_NOTIFICATIONS_PUSH1',
                type: 'link',
                icon: 'ti-cloud-up'
            },
            {
                state: 'financial-data',
                short_label: 'k',
                name: 'TRANS_MAIN_MENU.TRANS_FINANCIAL_DATA',
                type: 'link',
                icon: 'ti-money'
            },
            {
                state: 'b2b-statistics',
                short_label: 'k',
                name: 'TRANS_MAIN_MENU.TRANS_STATISTICS',
                type: 'link',
                icon: 'ti-stats-up'
            }
        ]
    },
    {
        label: 'TRANS_MAIN_MENU.TRANS_USER_MANAGEMENT',
        main: [
            {
                state: 'user-manager',
                short_label: 'l',
                name: 'TRANS_MAIN_MENU.TRANS_USERS',
                type: 'link',
                icon: 'ti-id-badge',
            },
            {
                state: 'register-request',
                short_label: 'q',
                name: 'TRANS_MAIN_MENU.TRANS_REGISTER_REQUESTS',
                type: 'link',
                icon: 'ti-credit-card',
                badge: [
                    {
                        type: 'success',
                        value: '2'
                    }
                ]
            }
        ]
    },
    {
        label: 'TRANS_MAIN_MENU.TRANS_STATISTICS',
        main: [
            {
                state: 'culture-app-stats',
                short_label: 'S',
                name: 'TRANS_MAIN_MENU.TRANS_APP_CULTURE_APP',
                type: 'link',
                icon: 'ti-android',
            },
            {
                state: 'b2b-stats',
                short_label: 'T',
                name: 'TRANS_MAIN_MENU.TRANS_B2B',
                type: 'link',
                icon: 'ti-link',
            },
            {
                state: 'google-analytics',
                short_label: 'U',
                name: 'TRANS_MAIN_MENU.TRANS_GOOGLE_ANALYTICS',
                type: 'link',
                icon: 'ti-google',
            },
        ]
    },
    {
        label: 'TRANS_MAIN_MENU.TRANS_SYSTEM',
        main: [
            {
                state: 'dbactions',
                short_label: 'V',
                name: 'TRANS_MAIN_MENU.TRANS_DATA_BASES',
                type: 'link',
                icon: 'ti-harddrives',

            },
            {
                state: 'file-manager',
                short_label: 'W',
                name: 'TRANS_MAIN_MENU.TRANS_FILE_MANAGEMENT',
                type: 'link',
                icon: 'ti-files',
            },
            {
                state: 'email-settings',
                short_label: 'X',
                name: 'TRANS_MAIN_MENU.TRANS_EMAIL_SETTINGS',
                type: 'link',
                icon: 'ti-email',
            },
            {
                state: 'server-info',
                short_label: 'Y',
                name: 'TRANS_MAIN_MENU.TRANS_SERVER_INFO',
                type: 'link',
                icon: 'ti-server',
            },
            {
                state: 'admin-contact',
                short_label: 'Z',
                name: 'TRANS_MAIN_MENU.TRANS_ADMIN_CONTACT',
                type: 'link',
                icon: 'ti-help-alt',
            },
            {
                state: 'theme-options',
                short_label: 'A',
                name: 'TRANS_MAIN_MENU.TRANS_THEME_OPTIONS',
                type: 'link',
                icon: 'ti-palette'
            }

        ]
    },
    {
        label: '',
        main: []
    }
],
    ROLE_USER: [
        {
            label: 'TRANS_MAIN_MENU.TRANS_GENERAL',
            main: [
                {
                    state: 'dashboard',
                    short_label: 'D',
                    name: 'TRANS_MAIN_MENU.TRANS_DASHBOARD',
                    type: 'link',
                    icon: 'ti-home',
                },
                {
                    state: 'profile',
                    short_label: 'S',
                    name: 'TRANS_MAIN_MENU.TRANS_PROFILE',
                    type: 'link',
                    icon: 'ti-user'
                },
                {
                    state: 'userpassword',
                    short_label: 'P',
                    name: 'TRANS_MAIN_MENU.TRANS_CHANGE_PASS',
                    type: 'link',
                    icon: 'ti-lock'
                }
            ]
        },
        {
            label: 'TRANS_MAIN_MENU.TRANS_APP_CULTURE_APP',
            main: [
                {
                    state: 'archeological-sites',
                    short_label: 'Α',
                    name: 'TRANS_MAIN_MENU.TRANS_ARCHEOLOGICAL_SITES',
                    type: 'sub',
                    icon: 'ti-ink-pen',
                    children: [
                        {
                            state: 'archeological-sites-view-all',
                            name: 'TRANS_MAIN_MENU.TRANS_VIEW_ALL'
                        }
                    ]
                },
                {
                    state: 'monuments',
                    short_label: 'M',
                    name: 'TRANS_MAIN_MENU.TRANS_MONUMENTS',
                    type: 'sub',
                    icon: 'ti-crown',
                    children: [
                        {
                            state: 'monuments-view-all',
                            name: 'TRANS_MAIN_MENU.TRANS_VIEW_ALL'
                        }
                    ]
                }
            ]
        },
        {
            label: 'TRANS_MAIN_MENU.TRANS_B2B',
            main: [
                {
                    state: 'groups',
                    short_label: 'G',
                    name: 'TRANS_MAIN_MENU.TRANS_GROUPS',
                    type: 'link',
                    icon: 'ti-signal',
                },
                {
                    state: 'guides',
                    short_label: 'H',
                    name: 'TRANS_MAIN_MENU.TRANS_GUIDES',
                    type: 'link',
                    icon: 'ti-direction-alt'
                },
                {
                    state: 'coupons',
                    short_label: 'Ι',
                    name: 'TRANS_MAIN_MENU.TRANS_COUPONS',
                    type: 'link',
                    icon: 'ti-medall-alt'
                },
                {
                    state: 'notifications',
                    short_label: 'j',
                    name: 'TRANS_MAIN_MENU.TRANS_NOTIFICATIONS_PUSH1',
                    type: 'link',
                    icon: 'ti-cloud-up'
                },
                {
                    state: 'financial-data',
                    short_label: 'k',
                    name: 'TRANS_MAIN_MENU.TRANS_FINANCIAL_DATA',
                    type: 'link',
                    icon: 'ti-money'
                },
                {
                    state: 'b2b-statistics',
                    short_label: 'k',
                    name: 'TRANS_MAIN_MENU.TRANS_STATISTICS',
                    type: 'link',
                    icon: 'ti-stats-up'
                }
            ]
        },
        {
            label: 'TRANS_MAIN_MENU.TRANS_STATISTICS',
            main: [
                {
                    state: 'b2b-stats',
                    short_label: 'T',
                    name: 'TRANS_MAIN_MENU.TRANS_B2B',
                    type: 'link',
                    icon: 'ti-link',
                }
            ]
        },
        {
            label: 'TRANS_MAIN_MENU.TRANS_SYSTEM',
            main: [
                {
                    state: 'email-settings',
                    short_label: 'X',
                    name: 'TRANS_MAIN_MENU.TRANS_EMAIL_SETTINGS',
                    type: 'link',
                    icon: 'ti-email',
                },
                {
                    state: 'server-info',
                    short_label: 'Y',
                    name: 'TRANS_MAIN_MENU.TRANS_SERVER_INFO',
                    type: 'link',
                    icon: 'ti-server',
                },
                {
                    state: 'admin-contact',
                    short_label: 'Z',
                    name: 'TRANS_MAIN_MENU.TRANS_ADMIN_CONTACT',
                    type: 'link',
                    icon: 'ti-help-alt',
                }
            ]
        },
        {
            label: '',
            main: []
        }
    ]
};

@Injectable()
export class MenuItems {
    getAll(role): Menu[] {
        return MENUITEMS[role];
    }
}
